import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllContratoUseCase } from "../../../presentation/useCases/read/get_all_contrato_use_case";
import { ContratoFilter } from "../../models/contrato_filter";
import { ContratoLista } from "../../models/contrato_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
export class GetAllContratoUseCase
  extends BasePaginatedUseCase<ContratoLista>
  implements IGetAllContratoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemContrato(
    filter: ContratoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemContrato(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
